<stby-modal-base
    [class.stby-modal--scroll-page]="scrollBehavior() === 'page'"
    [preventLightDismiss]="preventLightDismiss()"
    [hideCloseButton]="denyClose()"
    [beforeClose]="handleBeforeClose"
    [(visible)]="modalOpen"
>
    <div
        class="stby-modal"
        [class]="'stby-modal--' + size()"
        [class.stby-modal--wide]="allowWide()"
        [class.stby-modal--overflow]="allowOverflow()"
        [class.stby-modal--scroll-page]="scrollBehavior() === 'page'"
    >
        <h3 class="stby-modal__title" [class.hidden]="!modalTitleHasContent()">
            <ng-content select="stby-modal-title"></ng-content>
        </h3>
        <div class="stby-modal__content" cdkScrollable [class.hidden]="!modalContentHasContent()">
            <ng-content select="stby-modal-content"></ng-content>
            <ng-content select="[modal-content]"></ng-content>
        </div>
        <div class="stby-modal__cta-container" [class.hidden]="!modalCtaHasContent()">
            <ng-content select="stby-modal-cta"></ng-content>
        </div>
    </div>
</stby-modal-base>
